<template>
  <q-page padding>
    <div v-if="dados" class="row col-12 q-mt-sm">
      <div class="row col-12">
        <div class="col-5 q-mr-md">
          <QrCode class="print" :value="qrcodeCodigo" :size="150" />
          <QrCode class="visivel" :value="qrcodeCodigo" :size="400" />
        </div>
        <div class="col">
          <div class="row col-12 text-nome-container container-dados">
            <span
              style="word-wrap: break-word; width: 100%"
              class="text-multiplo-nome q-pa-md"
              >{{ multiplo > 0 ? `${multiplo}X` : "" }} {{ dados.name }}</span
            >
          </div>
          <div class="row col-12 text-code-container q-gutter-xs">
            <div class="row col-4 container-dados justify-center">
              <span class="text-nome q-pa-md">{{ measurementUnit }}</span>
            </div>
            <div class="row col container-dados justify-center items-center">
              <span class="text-nome q-pa-md">Código: {{ dados.code }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import QrCode from "../components/QrCode.vue";
export default {
  components: { QrCode },
  setup() {
    const store = useStore();
    const route = useRoute();
    const dados = ref();
    const produtoId = route.params.produtoId;
    const contractId = route.params.contractId;
    const qrcodeCodigo = ref("");
    let size = ref();

    const multiplo = computed(() => {
      return dados.value?.stock?.[0]?.pivot?.multiplo || 1;
    });

    const measurementUnit = computed(() => {
      return dados.value?.stock?.[0]?.pivot?.measurement_unit || "UN";
    });

    const recebeDados = async () => {
      store.dispatch("pdt/hiddenHeader", false);
      try {
        let response = await store.dispatch("produtos/listarProdutos", {
          per_page: 1,
          search: produtoId,
          contract_id: contractId,
        });
        dados.value = response.data.model.products.data[0];
        const mult = dados.value?.stock?.[0]?.pivot?.multiplo || 1;
        qrcodeCodigo.value = `00000000${mult}FFFFFF${dados.value.code?.trim()}`;
        setTimeout(() => {
          window.print();
        }, 1000);
      } catch (error) {
        console.log(error);
      }
    };
    onMounted(recebeDados);
    return {
      dados,
      produtoId,
      size,
      qrcodeCodigo,
      contractId,
      multiplo,
      measurementUnit,
    };
  },
};
</script>

<style scoped>
@page {
  margin: 3mm;
  size: 105mm 55mm;
}
.print {
  display: none;
}
.etiqueta-nome-container {
  border: 4px solid black;
  border-radius: 10px;
  margin-bottom: 10px;
}
.container-dados {
  border: 4px solid black;
  border-radius: 10px;
  margin-bottom: 10px;
}
.etiqueta-nome {
  font-size: 27px;
}
.text-nome-container {
  min-height: 77%;
}
.text-nome {
  font-size: 23px;
}
.text-multiplo-nome {
  font-size: 28px;
  padding: 6px;
}
@media print {
  .teste {
    display: block;
  }
  .print {
    display: block;
  }
  .visivel {
    display: none;
  }
  .etiqueta-nome-container {
    border: 1px solid black;
    border-radius: 10px;
    margin-bottom: 5px;
  }
  .container-dados {
    border: 1px solid black;
    border-radius: 10px;
    margin-bottom: 5px;
  }
  .etiqueta-nome {
    font-size: 14px;
  }
  .etiqueta-nome {
    font-size: 14px;
  }
  .text-nome {
    font-size: 8px;
    padding: 2px;
  }
  .text-multiplo-nome {
    font-size: 18px;
    padding: 6px;
  }
  .text-nome-container {
    min-height: 83%;
  }
}
</style>
